import { withTranslation } from "react-i18next";
import withRouter from "../../../../components/Common/withRouter";

const TaxReports= (props) => {
  return (
     <div className=" p-3">
     
      <h5 className=" fw-bold"> {props.t("tax_reports")}</h5>
      </div>
  )
}

export default withRouter(withTranslation()(TaxReports));